import React from 'react';
import { Button, Form, Input } from 'antd';
import { EyeInvisibleOutlined, EyeOutlined, LockOutlined, MailOutlined } from '@ant-design/icons';
import { Control, Controller } from 'react-hook-form';
import { isEmail } from '../../../utils/EmailUtils';
import { useAuthState } from '../../../redux/selector';

export interface EmailPasswordFormValues {
  email: string;
  password: string;
}

interface EmailPasswordFormProps {
  control: Control<EmailPasswordFormValues>;
  submitText: string;
  onSubmit: () => void;
}

const EmailPasswordForm: React.FC<EmailPasswordFormProps> = ({ control, submitText, onSubmit }) => {
  const { loading } = useAuthState();
  return (
    <>
      <Form layout="vertical" onFinish={onSubmit}>
        <Controller
          control={control}
          name="email"
          rules={{
            required: 'Please input your email',
            validate: (value) => {
              if (!isEmail(value)) {
                return 'Please enter a valid email!';
              }
              return true;
            },
          }}
          render={({ field, fieldState }) => (
            <Form.Item validateStatus={fieldState.error && 'error'} help={fieldState.error?.message}>
              <Input
                size="large"
                className="border-content-secondary shadow-none"
                autoCapitalize="off"
                autoCorrect="off"
                prefix={<MailOutlined className="text-content-secondary mr-1" />}
                placeholder="Email"
                {...field}
              />
            </Form.Item>
          )}
        />
        <Controller
          control={control}
          name="password"
          rules={{
            required: 'Please input your password',
          }}
          render={({ field, fieldState }) => (
            <Form.Item validateStatus={fieldState.error && 'error'} help={fieldState.error?.message}>
              <Input.Password
                size="large"
                className="border-content-secondary shadow-none"
                prefix={<LockOutlined className="text-content-secondary mr-1" />}
                iconRender={(visible) => {
                  // div is necessary to escape default style.
                  return (
                    <div>
                      {visible ? (
                        <EyeInvisibleOutlined className="text-content-secondary" />
                      ) : (
                        <EyeOutlined className="text-content-secondary" />
                      )}
                    </div>
                  );
                }}
                placeholder="Password"
                {...field}
              />
            </Form.Item>
          )}
        />
        <Form.Item>
          <Button size="large" type="primary" htmlType="submit" block loading={loading}>
            {submitText}
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default EmailPasswordForm;
